import styled from 'styled-components';

export const BodyContainer = styled.div`
  margin: 2rem auto 1rem auto;
  text-align: center;
  max-width: 20rem;
`;

export const ItemContainer = styled.div`
  margin-top: 1rem;
`;

export const SubtitleContainer = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
`;
